<template>
    <div class="load-more-container" v-if="hasMoreProducts || isLoading">
        <button 
            v-if="hasMoreProducts"
            @click="handleLoadMore" 
            :disabled="isLoading"
            class="btn-load-more"
        >
            <span v-if="!isLoading">Cargar más productos</span>
            <span v-else>
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Cargando...
            </span>
        </button>

        <div v-if="pagination.total > 0" class="pagination-info mt-3">
            Mostrando <strong>{{ currentProductsCount }}</strong> de <strong>{{ pagination.total }}</strong> productos
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useProductsStore } from '@/stores/products'

const productsStore = useProductsStore()
const { isLoading, pagination, hasMoreProducts, products } = storeToRefs(productsStore)

const currentProductsCount = computed(() => products.value.length)

const handleLoadMore = async () => {
    await productsStore.loadMoreProducts()
}
</script>

<style scoped>
.load-more-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem 0;
    margin-top: 1rem;
}

.btn-load-more {
    background: linear-gradient(135deg, #ed8600 0%, #e9a852 100%);
    border: none;
    color: white;
    padding: 0.875rem 2.5rem;
    font-size: 1rem;
    font-weight: 600;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
    min-width: 200px;
}

.btn-load-more:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}

.btn-load-more:active:not(:disabled) {
    transform: translateY(0);
}

.btn-load-more:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.pagination-info {
    color: #6c757d;
    font-size: 0.9rem;
    text-align: center;
}

.pagination-info strong {
    color: #495057;
    font-weight: 600;
}

@media (max-width: 576px) {
    .btn-load-more {
        width: 100%;
        max-width: 280px;
    }
}
</style>
